import { DomainError } from "./DomainError";

export class InvalidSessionTokenError extends DomainError {
  constructor(message = "Token de sesión de checkout inválido") {
    super(message);
    this.name = "InvalidSessionTokenError";
  }
}
